import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const THRESHOLD = 80;

const scrolledInside = (el) => {
  for (let n = el; n && n !== document.body; n = n.parentElement) if (n.scrollTop > 0) return true;
  return false;
};

export const PullToRefresh = () => {
  const [pull, setPull] = useState(0);
  const start = useRef(null);
  const dist = useRef(0);

  useEffect(() => {
    const down = (e) => {
      const blocked = window.scrollY > 0 || scrolledInside(e.target) || document.querySelector('[data-testid$="-modal"]');
      start.current = blocked ? null : e.touches[0].clientY;
      dist.current = 0;
    };
    const move = (e) => {
      if (start.current === null) return;
      dist.current = Math.max(0, Math.min(120, e.touches[0].clientY - start.current));
      setPull(dist.current);
    };
    const up = () => {
      if (start.current === null) return;
      start.current = null;
      if (dist.current >= THRESHOLD) window.location.reload();
      else setPull(0);
    };
    window.addEventListener("touchstart", down, { passive: true });
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("touchend", up);
    return () => { window.removeEventListener("touchstart", down); window.removeEventListener("touchmove", move); window.removeEventListener("touchend", up); };
  }, []);

  if (pull <= 10) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[100] flex justify-center pointer-events-none" style={{ transform: `translateY(${pull / 2}px)` }} data-testid="pull-to-refresh">
      <div className="bg-[#0A0A0A] border border-[#D4AF37]/50 rounded-full p-2.5 shadow-lg">
        <RefreshCw size={18} className={`text-[#D4AF37] ${pull >= THRESHOLD ? "animate-spin" : ""}`} style={{ transform: pull < THRESHOLD ? `rotate(${pull * 3}deg)` : undefined }} />
      </div>
    </div>
  );
};
